import { render, staticRenderFns } from "./CircleImageAvatar.vue?vue&type=template&id=1b88595e&"
import script from "./CircleImageAvatar.vue?vue&type=script&lang=js&"
export * from "./CircleImageAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports